import React, { useState } from 'react';

const AgeStep = ({ answers, setAnswers }) => {
  const [inputValue, setInputValue] = useState(answers.age?.toString() || '');
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    
    // Clear error when user starts typing
    if (error) setError('');
    
    // Only update answers if it's a valid number
    const numValue = parseInt(value);
    if (value === '' || (numValue >= 18 && numValue <= 70)) {
      setAnswers(prev => ({
        ...prev,
        age: value === '' ? '' : numValue
      }));
    }
  };

  const handleBlur = () => {
    const numValue = parseInt(inputValue);
    if (inputValue === '') {
      setError('لطفا سن خود را وارد کنید');
    } else if (numValue < 18) {
      setError('سن باید حداقل ۱۸ سال باشد');
    } else if (numValue > 70) {
      setError('سن نمی‌تواند بیشتر از ۷۰ سال باشد');
    } else if (isNaN(numValue)) {
      setError('لطفا یک عدد معتبر وارد کنید');
    }
  };

  const handleQuickSelect = (age) => {
    setInputValue(age.toString());
    setAnswers(prev => ({
      ...prev,
      age: age
    }));
    setError('');
  };

  return (
    <div className="text-center">
      <h2 className="text-2xl font-bold mb-6 text-gray-800">لطفا سن خود را انتخاب کنید</h2>
      
      <div className="px-4 space-y-6">
        {/* Instructions */}
        <div className="text-center mb-4">
          <p className="text-gray-600 text-sm">
            سن خود را دستی وارد کنید یا از لیست زیر انتخاب کنید
          </p>
        </div>

        {/* Number Input */}
        <div className="relative">
          <input
            type="number"
            min="18"
            max="70"
            value={inputValue}
            onChange={handleInputChange}
            onBlur={handleBlur}
            placeholder="مثال: ۲۵"
            className={`w-full px-4 py-4 text-center text-2xl font-bold border-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all duration-200 ${
              error 
                ? 'border-red-300 focus:border-red-500 focus:ring-red-200' 
                : 'border-gray-300 focus:border-indigo-500'
            }`}
            style={{ direction: 'ltr' }}
          />
          {inputValue && !error && (
            <span className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500 text-lg">
              سال
            </span>
          )}
        </div>

        {/* Error Message */}
        {error && (
          <div className="text-red-500 text-sm bg-red-50 p-3 rounded-lg">
            {error}
          </div>
        )}

        {/* Quick Select Buttons */}
        <div className="space-y-3">
          <p className="text-gray-600 text-sm font-medium">انتخاب سریع از لیست:</p>
          <div className="grid grid-cols-3 gap-2">
            {[18, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70].map((age) => (
              <button
                key={age}
                onClick={() => handleQuickSelect(age)}
                className={`py-3 px-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                  answers.age === age
                    ? 'bg-indigo-600 text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {age} سال
              </button>
            ))}
          </div>
        </div>

        {/* Age Range Info */}
        <div className="text-xs text-gray-500 bg-gray-50 p-3 rounded-lg">
          <p>سن باید بین ۱۸ تا ۷۰ سال باشد</p>
        </div>
      </div>
    </div>
  );
};

export default AgeStep; 